
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class SearchCustomer extends Vue {
    @Getter employeeList: any;
    @Prop() chooseEmployeeVisible: boolean;
    @Prop() confirmSelectedEmployee: Function;
    @Action('getEmpliyeeList') getEmpliyeeList: Function;

    searchVal: string = '';
    selectedEmployee: {[key: string]: any} = {};

    // 关闭弹窗
    handleClose() {
        // 清空表格数据
        this.closeVisible();
    }

    setCurrent(row: number) {
        (this.$refs.singleTable as any).setCurrentRow(row);
    }

    handleCurrentChange(val: {[key: string]: any}) {
        this.selectedEmployee = val;
    }

    // 关闭窗口
    closeVisible() {
        this.searchVal = '';
        this.selectedEmployee = {};
        this.$emit('closeChooseEmployeeVisible', true);
    }

    handleSelect(key: any) {
        this.searchVal = '';
        this.$emit('closeChooseEmployeeVisible', true);
    }

    // 确认选择的条目
    confirmbtn() {
        this.confirmSelectedEmployee(this.selectedEmployee);
    }

    // 确认搜索
    onSubmit() {
        this.getEmpliyeeList({keyword: this.searchVal, isPage: false, top: 100});
    }

}
